// Premium Spotlight: inserta un bloque entre "Negocios Destacados" y "Categorías Populares"
(function () {
  const API_BASE = window.apiConfig?.baseURL || (function(){ try { return window.location.hostname.match(/localhost|127\.0\.0\.1/) ? `${location.protocol}//${location.hostname}:3000/api/v1` : `${location.origin}/api/v1`; } catch { return `${location.protocol}//${location.hostname}/api/v1`; } })();
  const BACKEND_ORIGIN = (() => { try { return new URL(API_BASE).origin; } catch { return `${location.protocol}//${location.hostname}`; } })();

  // Detectar idioma desde la URL
  function getLang() {
    const path = window.location.pathname;
    if (path.startsWith('/en/')) return 'en';
    if (path.startsWith('/fr/')) return 'fr';
    if (path.startsWith('/de/')) return 'de';
    return 'es';
  }

  // Traducciones
  const translations = {
    es: {
      title: 'Productos Destacados Premium',
      subtitle: 'Productos promocionados de cuentas Premium.'
    },
    en: {
      title: 'Featured Premium Products',
      subtitle: 'Promoted products from Premium accounts.'
    },
    fr: {
      title: 'Produits Premium En Vedette',
      subtitle: 'Produits promus de comptes Premium.'
    },
    de: {
      title: 'Premium Produkte',
      subtitle: 'Beworbene Produkte von Premium-Konten.'
    }
  };

  const lang = getLang();
  const t = translations[lang] || translations.es;

  function normalizeImg(src, kind) {
    try {
      if (!src) return '';
      if (/^https?:\/\//i.test(src)) return src; // Absoluta (p.ej., R2) -> usar tal cual
      if (src.startsWith('/uploads/')) return `https://cdn.publikaya.com${src}`; // Forzar CDN
      // bare filename
      if (!src.startsWith('/')) {
        if (kind === 'logo') return `https://cdn.publikaya.com/uploads/logos/${src}`;
        if (kind === 'product') return `https://cdn.publikaya.com/uploads/products/${src}`;
      }
      return src;
    } catch { return src || ''; }
  }

  function fixRelativeUploadsOnPage() {
    try {
      document.querySelectorAll('img[src^="/uploads/"]').forEach(img => {
        const s = img.getAttribute('src');
        if (s && !/^https?:\/\//i.test(s)) {
          img.src = `https://cdn.publikaya.com${s}`;
        }
      });
    } catch {}
  }

  function currency(n) {
    if (n == null || isNaN(n)) return '';
    try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n); } catch { return `$${n}`; }
  }

  function escapeHtml(text) {
    const s = text == null ? '' : String(text);
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    try {
      const u = new URL(url, window.location.origin);
      const p = u.protocol.toLowerCase();
      if (p === 'http:' || p === 'https:') return u.href;
      return '';
    } catch { return ''; }
  }

  function createSkeleton() {
    const wrap = document.createElement('section');
    wrap.className = 'premium-spotlight';
    wrap.replaceChildren();

    const container = document.createElement('div');
    container.className = 'container';

    const h2 = document.createElement('h2');
    h2.className = 'title';
    h2.textContent = t.title;

    const p = document.createElement('p');
    p.className = 'subtitle';
    p.textContent = t.subtitle;

    const grid = document.createElement('div');
    grid.className = 'premium-spotlight-skeleton-grid';

    const makeSkeleton = () => {
      const sk = document.createElement('div');
      sk.className = 'premium-spotlight-skeleton';
      const img = document.createElement('div');
      img.className = 'img';
      const text = document.createElement('div');
      text.className = 'text';
      const mkLine = (cls) => {
        const line = document.createElement('div');
        line.className = `line ${cls}`;
        return line;
      };
      text.appendChild(mkLine('long'));
      text.appendChild(mkLine('mid'));
      text.appendChild(mkLine('short'));
      text.appendChild(mkLine('long'));
      sk.appendChild(img);
      sk.appendChild(text);
      return sk;
    };

    grid.appendChild(makeSkeleton());
    grid.appendChild(makeSkeleton());

    container.appendChild(h2);
    container.appendChild(p);
    container.appendChild(grid);
    wrap.appendChild(container);
    return wrap;
  }

  function renderProductCardElement(product) {
    const imgUrl = safeUrl(normalizeImg(product.image_url, 'product'));
    const biz = product.business || {};
    const logoUrl = safeUrl(normalizeImg(biz.logo_url, 'logo'));

    const productName = product && product.name ? String(product.name) : 'Producto';
    const productDesc = product && product.description ? String(product.description) : '';
    const bizName = biz && biz.name ? String(biz.name) : '';
    const bizLoc = [biz.city, biz.country].filter(Boolean).join(', ');

    const article = document.createElement('article');
    article.className = 'premium-spotlight-card';

    const imgWrap = document.createElement('div');
    imgWrap.className = 'premium-spotlight-image';
    if (imgUrl) {
      const img = document.createElement('img');
      img.src = imgUrl;
      img.alt = productName;
      img.loading = 'lazy';
      img.decoding = 'async';
      imgWrap.appendChild(img);
    } else {
      const ph = document.createElement('div');
      ph.style.height = '220px';
      ph.style.background = '#e5e7eb';
      imgWrap.appendChild(ph);
    }
    const badge = document.createElement('span');
    badge.className = 'premium-spotlight-badge';
    badge.textContent = 'PREMIUM';
    imgWrap.appendChild(badge);

    const body = document.createElement('div');
    body.className = 'premium-spotlight-body';

    const h3 = document.createElement('h3');
    h3.className = 'premium-spotlight-name';
    h3.textContent = productName;

    body.appendChild(h3);

    if (productDesc) {
      const p = document.createElement('p');
      p.className = 'premium-spotlight-desc';
      p.textContent = productDesc;
      body.appendChild(p);
    }

    if (product && product.price != null) {
      const price = document.createElement('div');
      price.className = 'premium-spotlight-price';
      price.textContent = currency(product.price);
      body.appendChild(price);
    }

    const bizRow = document.createElement('div');
    bizRow.className = 'premium-spotlight-biz';
    if (logoUrl) {
      const img = document.createElement('img');
      img.src = logoUrl;
      img.alt = bizName;
      bizRow.appendChild(img);
    } else {
      const ph = document.createElement('div');
      ph.style.width = '32px';
      ph.style.height = '32px';
      ph.style.borderRadius = '50%';
      ph.style.background = '#e2e8f0';
      bizRow.appendChild(ph);
    }
    const bizTextWrap = document.createElement('div');
    const bn = document.createElement('div');
    bn.className = 'biz-name';
    bn.textContent = bizName;
    const bl = document.createElement('div');
    bl.className = 'biz-loc';
    bl.style.fontSize = '12px';
    bl.style.color = '#64748b';
    bl.textContent = bizLoc;
    bizTextWrap.appendChild(bn);
    bizTextWrap.appendChild(bl);
    bizRow.appendChild(bizTextWrap);
    body.appendChild(bizRow);

    // ❤️ Like button for the business
    try {
      const bizId = (biz && biz.id) || product.business_id || '';
      const likeOptions = {};
      if (typeof biz?.likes_count === 'number') likeOptions.count = biz.likes_count;
      const likeWrapper = document.createElement('div');
      likeWrapper.style.cssText = 'display:flex; justify-content:flex-end; padding:0 0.5rem;';
      const likeBtn = window.LikesUI && window.LikesUI.createLikeButton(bizId, likeOptions);
      if (likeBtn) likeWrapper.appendChild(likeBtn);
      body.appendChild(likeWrapper);
    } catch (_) {}

    const actions = document.createElement('div');
    actions.className = 'premium-spotlight-actions';
    if (biz && biz.slug) {
      const a = document.createElement('a');
      a.className = 'premium-spotlight-btn primary btn-vitrina';
      a.href = `/vitrina-plus.html?slug=${encodeURIComponent(String(biz.slug))}`;
      a.appendChild(document.createTextNode('Vitrina+'));
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'icon');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M7 5l6 5-6 5');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      a.appendChild(svg);
      actions.appendChild(a);
    }
    const cats = document.createElement('a');
    cats.className = 'premium-spotlight-btn ghost';
    cats.href = '/categories.html';
    cats.textContent = 'Categorías';
    actions.appendChild(cats);
    body.appendChild(actions);

    article.appendChild(imgWrap);
    article.appendChild(body);
    return article;
  }

  function renderProducts(products) {
    const section = document.createElement('section');
    section.className = 'premium-spotlight';

    section.replaceChildren();

    const container = document.createElement('div');
    container.className = 'container';

    const h2 = document.createElement('h2');
    h2.className = 'title';
    h2.textContent = t.title;

    const p = document.createElement('p');
    p.className = 'subtitle';
    p.textContent = t.subtitle;

    const grid = document.createElement('div');
    grid.className = products.length === 1 ? 'premium-spotlight-grid-single' : 'premium-spotlight-grid';

    const frag = document.createDocumentFragment();
    (Array.isArray(products) ? products : []).forEach((product) => {
      try {
        const el = renderProductCardElement(product);
        if (el) frag.appendChild(el);
      } catch {}
    });
    grid.appendChild(frag);

    container.appendChild(h2);
    container.appendChild(p);
    container.appendChild(grid);
    section.appendChild(container);

    return section;
  }

  function insertAfterCategories(section) {
    // PRIORIDAD 1: Insertar antes de "Descubre los negocios Premium"
    const featuredBusinesses = document.querySelector('section.featured-businesses-section');
    if (featuredBusinesses && featuredBusinesses.parentElement) {
      featuredBusinesses.parentElement.insertBefore(section, featuredBusinesses);
      return true;
    }
    
    // PRIORIDAD 2: Insertar después de Categorías Populares
    const categories = document.querySelector('section.categories-populares');
    if (categories && categories.parentElement) {
      categories.parentElement.insertBefore(section, categories.nextSibling);
      return true;
    }
    
    // Fallback: al final del contenedor donde están los destacados
    const featured = document.querySelector('#featured-businesses');
    if (featured) {
      const wrapper = featured.closest('section') || document.body;
      wrapper.parentElement.insertBefore(section, wrapper.nextSibling);
      return true;
    }
    
    // Último recurso: al final del body
    document.body.appendChild(section);
    return true;
  }

  async function loadSpotlight() {
    const skeleton = createSkeleton();
    insertAfterCategories(skeleton);

    try {
      // Función para hacer request con timeout manual (sin AbortController)
      const fetchWithTimeout = (url, timeout = 3000) => {
        return Promise.race([
          fetch(url, { credentials: 'omit' }),
          new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Timeout')), timeout)
          )
        ]);
      };

      // Helper: retry con backoff exponencial simple
      const fetchJsonWithRetry = async (url, { attempts = 2, baseDelay = 300, timeout = 3000 } = {}) => {
        let lastErr;
        for (let i = 0; i <= attempts; i++) {
          try {
            const res = await fetchWithTimeout(url, timeout);
            if (res && res.ok) {
              return await res.json();
            }
            lastErr = new Error(`HTTP ${res ? res.status : 'no-response'}`);
          } catch (err) {
            lastErr = err;
          }
          // backoff si hay siguiente intento
          if (i < attempts) {
            const delay = baseDelay * Math.pow(2, i) + Math.floor(Math.random() * 120);
            await new Promise(r => setTimeout(r, delay));
          }
        }
        throw lastErr || new Error('Unknown error');
      };

      // Hacer una sola llamada para obtener múltiples productos premium random
      // Optimizamos eliminando el probe y las múltiples llamadas paralelas
      let uniqueProducts = [];
      try {
        const raw = await fetchJsonWithRetry(`${API_BASE}/public/premium/random-product?limit=4`, { 
          attempts: 2, 
          baseDelay: 250, 
          timeout: 2800 
        }).catch(() => null);
        const json = raw || {};
        
        const products = json?.data?.products || (json?.data?.product ? [json.data.product] : []);
        
        // Filtrar para evitar productos del mismo usuario/negocio y limitar a 2 finales
        const usedBusinessIds = new Set();
        for (const product of products) {
          if (product && product.business) {
            const businessId = product.business.id || product.business_id;
            if (businessId && !usedBusinessIds.has(businessId) && uniqueProducts.length < 2) {
              uniqueProducts.push(product);
              usedBusinessIds.add(businessId);
            }
          }
        }
      } catch (err) {
        console.warn('[PremiumSpotlight] Error en la petición optimizada:', err);
      }

      if (uniqueProducts.length > 0) {
        const section = renderProducts(uniqueProducts);
        skeleton.remove();
        insertAfterCategories(section);
        // Disparar evento custom para que otros scripts sepan que ya se insertó
        window.dispatchEvent(new CustomEvent('premium-spotlight-loaded'));
      } else {
        skeleton.replaceWith(document.createComment('no premium products'));
        window.dispatchEvent(new CustomEvent('premium-spotlight-loaded'));
      }
      // asegurar que no queden src relativos a /uploads/
      fixRelativeUploadsOnPage();
    } catch (e) {
      console.warn('[PremiumSpotlight] Error cargando productos premium:', e);
      skeleton.replaceWith(document.createComment('premium spotlight error'));
      window.dispatchEvent(new CustomEvent('premium-spotlight-loaded'));
    }
  }

  document.addEventListener('DOMContentLoaded', loadSpotlight);
})();
// Force update 08/21/2025 21:41:00 - Fixed timeout method and premium product logic
